(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("element-ui"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", "element-ui"], factory);
	else if(typeof exports === 'object')
		exports["CustomsCn"] = factory(require("axios"), require("element-ui"));
	else
		root["CustomsCn"] = factory(root["axios"], root["element-ui"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__(11);
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// CONCATENATED MODULE: ./src/components/api/endpoint.js

/* harmony default export */ var endpoint = ({
  http: function http() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http://localhost:8080/';
    var instance = external_axios_default.a.create({
      baseURL: url,
      withCredentials: true
    });
    instance.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      return Promise.reject(error);
    });
    return instance;
  },
  no_interceptors_http: function no_interceptors_http() {
    var instance = external_axios_default.a.create({
      baseURL: this.url()
    });
    return instance;
  }
});
// CONCATENATED MODULE: ./src/components/api/index.js

/* harmony default export */ var api = __webpack_exports__["a"] = ({
  depList: function depList(serverURL, type) {
    return endpoint.http(serverURL).get("/code/dep/".concat(type)).then(function (response) {
      return response.data;
    });
  },
  gbList: function gbList(serverURL, type) {
    return endpoint.http(serverURL).get("/code/gb/".concat(type)).then(function (response) {
      return response.data;
    });
  },
  ciqList: function ciqList(serverURL, hsCode) {
    return endpoint.http(serverURL).get("/hscode/".concat(hsCode, "/ciq")).then(function (response) {
      return response.data;
    });
  },
  getElements: function getElements(serverURL, hsCode, type) {
    return endpoint.http(serverURL).get("/hscode/".concat(hsCode, "/elements/").concat(type)).then(function (response) {
      return response.data;
    });
  },
  getHsCode: function getHsCode(serverURL, hsCode) {
    return endpoint.http(serverURL).get("/hscode/".concat(hsCode)).then(function (response) {
      return response.data;
    });
  },
  lookupHSCode: function lookupHSCode(serverURL, query) {
    return endpoint.http(serverURL).get('/hscode', {
      params: {
        q: query
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getManual: function getManual(serverURL, id) {
    return endpoint.http(serverURL).get("/manual-api/".concat(id)).then(function (response) {
      return response.data;
    });
  },
  getManualHead: function getManualHead(serverURL, id) {
    return endpoint.http(serverURL).get("/manual-api/".concat(id, "/header")).then(function (response) {
      return response.data;
    });
  },
  getImportManualItem: function getImportManualItem(serverURL, id, seqNo, supvMode) {
    return endpoint.http(serverURL).get("/manual-api/import/".concat(id, "/item/").concat(seqNo), {
      params: {
        supvMode: supvMode
      }
    }).then(function (response) {
      return response.data;
    });
  },
  getExportManualItem: function getExportManualItem(serverURL, id, seqNo, supvMode) {
    return endpoint.http(serverURL).get("/manual-api/export/".concat(id, "/item/").concat(seqNo), {
      params: {
        supvMode: supvMode
      }
    }).then(function (response) {
      return response.data;
    });
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    enterLoop: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      refs: [],
      idx: 0
    };
  },
  watch: {
    refs: function refs(val) {
      this.refs = val;
    }
  },
  methods: {
    focusNext: function focusNext() {
      var ignoreHold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.refs.length <= 0) {
        return false;
      }

      if (this.idx + 1 >= this.refs.length && !this.enterLoop) {
        return false;
      }

      var nextCompIdx = (this.idx + 1) % this.refs.length;
      var comp = this.$refs[this.refs[this.idx]];
      console.debug('component focusNext current:' + this.refs[this.idx]);
      console.debug(comp);
      var entercontrol = comp.entercontrol || comp.$attrs.entercontrol;
      var ignoreh = ignoreHold || entercontrol !== 'hold';

      if (entercontrol === 'hold') {
        comp && comp.blur && comp.blur();
      }

      if (comp && ignoreh) {
        if (!(comp.focusNext && comp.focusNext())) {
          comp && comp.blur && comp.blur();
          var ncomp = this.$refs[this.refs[nextCompIdx]];
          console.debug('next comp name:' + this.refs[nextCompIdx]);
          console.debug(ncomp);

          if (ncomp) {
            if (ncomp.disabled || ncomp.entercontrol === 'skip') {
              console.debug('next entercontrol skipped!');
              this.idx = nextCompIdx;
              this.focusNext();
            } else {
              ncomp.focus && ncomp.focus(); // autocomplete component

              if (ncomp.$refs['input'] && ncomp.$refs['input'].select) {
                ncomp.$refs['input'].select();
              } else {
                ncomp.select && ncomp.select();
              }

              this.idx = nextCompIdx;
            }
          } else {
            this.idx = nextCompIdx;
          }
        }
      }

      return this.enterLoop || this.idx < this.refs.length;
    },
    focusedHandler: function focusedHandler(ref) {
      this.idx = this.refs.findIndex(function (r) {
        return r === ref;
      });
      this.$emit('focus');
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VariationSelect.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VariationSelect = ({
  name: 'VariationSelect',
  props: {
    placeholder: {
      type: String,
      default: function _default() {
        return '请选择';
      }
    },
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    justDisplay: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelName: {
      type: String,
      default: 'label'
    },
    valueName: {
      type: String,
      default: 'value'
    }
  },
  data: function data() {
    return {
      newValue: this.value,
      newName: null,
      selection: this.options,
      exactMatch: null
    };
  },
  watch: {
    value: function value() {
      this.syncName();
    },
    options: function options(val) {
      this.selection = val;
      this.syncName();
    }
  },
  created: function created() {
    this.syncName();
  },
  methods: {
    focus: function focus() {
      !this.disabled && this.$refs['sel'].focus && this.$refs['sel'].focus();
    },
    blur: function blur() {
      this.$refs['sel'].close && this.$refs['sel'].close();
    },
    select: function select() {
      this.$refs['sel'] && this.$refs['sel'].$refs && this.$refs['sel'].$refs['input'].select();
    },
    focusHandler: function focusHandler() {
      this.$emit('focus');
    },
    syncName: function syncName() {
      var _this = this;

      this.newName = null;

      if (this.value) {
        var sel = this.selection.filter(function (s) {
          return s[_this.valueName] === _this.value;
        });
        console.debug('syncname: ', sel);

        if (sel.length > 0) {
          this.newValue = sel[0][this.valueName];
          this.newName = sel[0][this.labelName];
        } else {
          this.newName = null;
        }
      }
    },
    search: function search(query, cb) {
      var _this2 = this;

      var sel = this.selection;
      var trimmed = query ? query.trim() : '';
      var results = query ? sel.filter(this.filterClause(trimmed)) : sel; // 把完全匹配的对象移到第一个

      var index = results.findIndex(function (result) {
        return _this2.match(result, trimmed);
      });

      if (index !== -1) {
        var deleteObj = results.splice(index, 1)[0];
        results.unshift(deleteObj);
      }

      cb(results);
      this.exactMatch = null;

      if (results.length > 0) {
        if (results.length === 1) {
          this.exactMatch = results[0];
        }
      }
    },
    match: function match(result, trimmed) {
      if (!trimmed) return;
      return result[this.labelName].toLowerCase() === trimmed.toLowerCase() || result[this.valueName].toLowerCase() === trimmed.toLowerCase();
    },
    blurHandler: function blurHandler() {
      var _this3 = this;

      // After enter handler
      this.$nextTick(function () {
        setTimeout(function () {
          var sel = _this3.selection.find(function (s) {
            return s[_this3.valueName] === _this3.newValue;
          });

          var codeName = sel && sel[_this3.labelName];

          if (codeName !== _this3.newName) {
            if (_this3.newName) {
              _this3.selectHandler({
                _value: _this3.newName
              });
            } else {
              _this3.$emit('change', null);

              _this3.$emit('input', null);
            }
          }
        }, 60);
      });
      this.$emit('blur');
    },
    selectHandler: function selectHandler(item) {
      var _this4 = this;

      if (item && item[this.valueName] && item[this.labelName]) {
        // selection from suggestion options
        this.newValue = item[this.valueName];
        this.newName = item[this.labelName];
      } else if (item && (item._value || item.value)) {
        // enter or blur select value
        var compValue = item._value ? item._value : item.value;
        this.search(compValue, function (val) {
          if (val.length > 0) {
            _this4.newValue = val[0][_this4.valueName];
            _this4.newName = val[0][_this4.labelName];
          } else {
            _this4.newValue = null;
            _this4.newName = null;
          }
        });
      } else if (this.exactMatch) {
        // previous query has unique result
        this.newValue = this.exactMatch[this.valueName];
        this.newName = this.exactMatch[this.labelName];
      } else {
        this.newValue = null;
        this.newName = null;
      }

      this.$emit('input', this.newValue);
      this.$emit('change', this.newValue, this.selection.find(function (v) {
        return v[_this4.valueName] === _this4.newValue;
      }));
    },
    filterClause: function filterClause(query) {
      var _this5 = this;

      return function (s) {
        return s[_this5.valueName] && s[_this5.valueName].toLowerCase().indexOf(query.toLowerCase()) === 0 || s[_this5.labelName] && s[_this5.labelName].toLowerCase().indexOf(query.toLowerCase()) >= 0;
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bcde36f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VariationSelect.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%" } }, [
    _vm.justDisplay
      ? _c("div", [_c("a", [_vm._v(_vm._s(_vm.newName))])])
      : _c(
          "div",
          [
            _c("el-autocomplete", {
              ref: "sel",
              staticStyle: { width: "100%" },
              attrs: {
                "fetch-suggestions": _vm.search,
                debounce: 0,
                disabled: _vm.disabled,
                "trigger-on-focus": false,
                "select-when-unmatched": "",
                "highlight-first-item": "",
                placeholder: _vm.placeholder
              },
              on: {
                focus: _vm.focusHandler,
                blur: _vm.blurHandler,
                select: _vm.selectHandler
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "box" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(item[_vm.valueName]) +
                              " - " +
                              _vm._s(item[_vm.labelName])
                          )
                        ])
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.newName,
                callback: function($$v) {
                  _vm.newName = $$v
                },
                expression: "newName"
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

if (false) {}
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/VariationSelect.vue
var disposed = false
function injectStyle (context) {
  if (disposed) return
  __webpack_require__(25)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bcde36f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  VariationSelect,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/VariationSelect.vue"

/* hot reload */
if (false) {}

/* harmony default export */ var components_VariationSelect = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], "{").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    for (var i = 0; i < this.length; i++) {
      // eslint-disable-next-line prefer-destructuring
      var id = this[i][0];

      if (id != null) {
        alreadyImportedModules[id] = true;
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = modules[_i]; // skip already imported module
      // this implementation is not 100% perfect for weird media query combinations
      // when a module is imported multiple times with different media queries.
      // I hope this will never occur (Hey this way we have smaller bundles)

      if (item[0] == null || !alreadyImportedModules[item[0]]) {
        if (mediaQuery && !item[2]) {
          item[2] = mediaQuery;
        } else if (mediaQuery) {
          item[2] = "(".concat(item[2], ") and (").concat(mediaQuery, ")");
        }

        list.push(item);
      }
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot).concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/api/index.js + 1 modules
var api = __webpack_require__(0);

// EXTERNAL MODULE: ./src/components/entercomms.js
var entercomms = __webpack_require__(2);

// CONCATENATED MODULE: ./src/components/cache.js
var CACHE = __webpack_require__(18);

/* harmony default export */ var cache = ({
  get: function get(key, loadFun, cb) {
    var val = CACHE.get(key);

    if (Array.isArray(val) && val.length > 0) {
      cb(val);
    } else {
      loadFun(key).then(function (data) {
        if (Array.isArray(data) && data.length > 0) {
          CACHE.set(key, data, 300000);
          cb(data);
        } else {
          cb([]);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CodeSelect.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CodeSelect = ({
  name: 'CodeSelect',
  mixins: [entercomms["a" /* default */]],
  props: {
    type: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    depGb: {
      type: String,
      default: 'dep'
    },
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    optionLimit: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    justDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      newValue: this.value,
      newName: null,
      selection: [],
      exactMatch: null
    };
  },
  watch: {
    value: function value() {
      this.syncName();
    }
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    focus: function focus() {
      !this.disabled && this.$refs['sel'].focus && this.$refs['sel'].focus();
    },
    blur: function blur() {
      this.$refs['sel'].close && this.$refs['sel'].close();
    },
    select: function select() {
      this.$refs['sel'] && this.$refs['sel'].$refs && this.$refs['sel'].$refs['input'].select();
    },
    loadData: function loadData() {
      var _this = this;

      var key = this.depGb + ':' + this.type;
      cache.get(key, function (key) {
        if (_this.depGb === 'gb') {
          return api["a" /* default */].gbList(_this.$serverURL, _this.type);
        } else {
          return api["a" /* default */].depList(_this.$serverURL, _this.type);
        }
      }, function (val) {
        _this.selection = val;

        _this.syncName();
      });
    },
    syncName: function syncName() {
      var _this2 = this;

      this.newName = null;

      if (this.value) {
        var sel = this.selection.find(function (s) {
          return s.codeValue === _this2.value;
        });

        if (sel) {
          this.newValue = sel.codeValue;
          this.newName = sel.codeName;
        } else {
          this.newName = null;
        }
      }
    },
    search: function search(query, cb) {
      var _this3 = this;

      var sel = this.selection;
      var trimmed = query ? query.trim() : '';
      var results = query ? sel.filter(this.filterClause(trimmed)) : sel; // 把完全匹配的对象移到第一个

      var index = results.findIndex(function (result) {
        return _this3.match(result, trimmed);
      });

      if (index !== -1) {
        var deleteObj = results.splice(index, 1)[0];
        results.unshift(deleteObj);
      }

      cb(this.optionLimit && this.optionLimit < results.length ? results.slice(0, this.optionLimit) : results);
      this.exactMatch = null;

      if (results.length > 0) {
        if (results.length === 1) {
          // is it the only match
          this.exactMatch = results[0];
        } // else {
        //   // find exact match if any
        //   var exact = results.filter(
        //     result => this.match(result, trimmed)
        //   )
        //   if (exact.length === 1) {
        //     this.exactMatch = exact[0]
        //   }
        // }

      }
    },
    match: function match(result, trimmed) {
      if (!trimmed) return;
      return result.codeName.toLowerCase() === trimmed.toLowerCase() || result.codeValue.toLowerCase() === trimmed.toLowerCase() || result.ciqCode && result.ciqCode.toLowerCase() === trimmed.toLowerCase() || result.cusCode && result.cusCode.toLowerCase() === trimmed.toLowerCase();
    },
    blurHandler: function blurHandler() {
      var _this4 = this;

      // After enter handler
      this.$nextTick(function () {
        setTimeout(function () {
          var sel = _this4.selection.find(function (s) {
            return s.codeValue === _this4.newValue;
          });

          var codeName = sel && sel.codeName;

          if (codeName !== _this4.newName) {
            if (_this4.newName) {
              _this4.selectHandler({
                value: _this4.newName
              });
            } else {
              _this4.$emit('change', null);

              _this4.$emit('input', null);
            }
          }
        }, 100);
      });
      this.$emit('blur');
    },
    selectHandler: function selectHandler(item) {
      var _this5 = this;

      if (item && item.codeValue) {
        // selection from suggestion options
        this.newValue = item.codeValue;
        this.newName = item.codeName;
      } else if (item && item.value) {
        // enter select value
        if (item.value) {
          this.search(item.value, function (val) {
            if (val.length > 0) {
              _this5.newValue = val[0].codeValue;
              _this5.newName = val[0].codeName;
            } else {
              _this5.newValue = null;
              _this5.newName = null;
            }
          });
        } else {
          this.newValue = null;
          this.newName = null;
        }
      } else if (this.exactMatch) {
        // previous query has unique result
        this.newValue = this.exactMatch.codeValue;
        this.newName = this.exactMatch.codeName;
      } else {
        this.newValue = null;
        this.newName = null;
      }

      this.$emit('input', this.newValue);
      this.$emit('change', this.newValue ? {
        label: this.newName,
        value: this.newValue
      } : null);
    },
    filterClause: function filterClause(query) {
      return function (s) {
        return s.codeValue && s.codeValue.toLowerCase().indexOf(query.toLowerCase()) === 0 || s.codeName && s.codeName.toLowerCase().indexOf(query.toLowerCase()) >= 0 || s.cusCode && s.cusCode.toLowerCase().indexOf(query.toLowerCase()) === 0 || s.ciqCode && s.ciqCode.toLowerCase().indexOf(query.toLowerCase()) === 0;
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7d36f9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeSelect.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%" } }, [
    _vm.justDisplay
      ? _c("span", [_vm._v(_vm._s(_vm.newName))])
      : _c(
          "div",
          [
            _c("el-autocomplete", {
              ref: "sel",
              staticStyle: { width: "100%" },
              attrs: {
                "fetch-suggestions": _vm.search,
                debounce: 0,
                disabled: _vm.disabled,
                "trigger-on-focus": false,
                "select-when-unmatched": "",
                "highlight-first-item": "",
                placeholder: "请输入内容"
              },
              on: {
                select: _vm.selectHandler,
                blur: _vm.blurHandler,
                focus: function($event) {
                  return _vm.focusedHandler("sel")
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "box" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(item.codeValue) +
                              " - " +
                              _vm._s(item.codeName)
                          )
                        ]),
                        _vm._v(" "),
                        item.cusCode
                          ? _c("small", { staticClass: "code" }, [
                              _vm._v(_vm._s(item.cusCode))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.ciqCode
                          ? _c("small", { staticClass: "code" }, [
                              _vm._v(_vm._s(item.ciqCode))
                            ])
                          : _vm._e()
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.newName,
                callback: function($$v) {
                  _vm.newName = $$v
                },
                expression: "newName"
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

if (false) {}
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/CodeSelect.vue
var disposed = false
function injectStyle (context) {
  if (disposed) return
  __webpack_require__(16)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c7d36f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  CodeSelect,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/CodeSelect.vue"

/* hot reload */
if (false) {}

/* harmony default export */ var components_CodeSelect = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/api/index.js + 1 modules
var api = __webpack_require__(0);

// EXTERNAL MODULE: ./src/components/VariationSelect.vue + 2 modules
var VariationSelect = __webpack_require__(3);

// EXTERNAL MODULE: ./src/components/entercomms.js
var entercomms = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CiqCodeSelect.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CiqCodeSelect = ({
  name: 'CiqCodeSelect',
  components: {
    VariationSelect: VariationSelect["a" /* default */]
  },
  mixins: [entercomms["a" /* default */]],
  props: {
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    hsCode: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    justDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      rows: []
    };
  },
  computed: {
    statcode: function statcode() {
      return this.value;
    }
  },
  watch: {
    hsCode: function hsCode(val) {
      this.getCiqList();
    }
  },
  created: function created() {
    this.getCiqList();
  },
  methods: {
    getCiqList: function getCiqList() {
      var _this = this;

      if (this.hsCode) {
        api["a" /* default */].ciqList(this.$serverURL, this.hsCode).then(function (data) {
          if (data) {
            _this.rows = data.map(function (v) {
              v.statcode = v.statcode.replace(_this.hsCode, '');
              v.label = v.ciqname;
              v.value = v.statcode;
              return v;
            });
          }
        });
      }
    },
    focus: function focus() {
      !this.disabled && this.$refs['sel'].focus && this.$refs['sel'].focus();
    },
    blur: function blur() {
      this.$refs['sel'].close && this.$refs['sel'].close();
    },
    select: function select() {
      this.$refs['sel'].select();
    },
    focusHandler: function focusHandler() {
      this.$emit('focus');
    },
    blurHandler: function blurHandler() {
      this.$emit('blur');
    },
    change: function change(val) {
      var row = this.rows.find(function (f) {
        return f.statcode === val;
      });
      this.$emit('ciq-row', val, row);
      this.$emit('change', val, row);
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c41ae74","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CiqCodeSelect.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("variation-select", {
    ref: "sel",
    attrs: {
      value: _vm.statcode,
      options: _vm.rows,
      disabled: _vm.disabled,
      "just-display": _vm.justDisplay
    },
    on: { focus: _vm.focusHandler, blur: _vm.blurHandler, change: _vm.change }
  })
}
var staticRenderFns = []
render._withStripped = true

if (false) {}
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/CiqCodeSelect.vue
var disposed = false
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  CiqCodeSelect,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/CiqCodeSelect.vue"

/* hot reload */
if (false) {}

/* harmony default export */ var components_CiqCodeSelect = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/api/index.js + 1 modules
var api = __webpack_require__(0);

// EXTERNAL MODULE: ./src/components/entercomms.js
var entercomms = __webpack_require__(2);

// EXTERNAL MODULE: external "element-ui"
var external_element_ui_ = __webpack_require__(12);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HscodeSelect.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var HscodeSelect = ({
  name: 'HscodeSelect',
  components: {
    ELAutocomplete: external_element_ui_["ELAutocomplete"]
  },
  mixins: [entercomms["a" /* default */]],
  props: {
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      code: null,
      hscodes: []
    };
  },
  watch: {
    value: function value(val) {
      this.code = val;
    }
  },
  methods: {
    handlerBlur: function handlerBlur() {
      this.$emit('blur');
    },
    handlerChange: function handlerChange() {
      this.$emit('change');
    },
    focus: function focus() {
      console.debug('hscode select forcused!');
      !this.disabled && this.$refs['sel'].focus && this.$refs['sel'].focus();
    },
    blur: function blur() {
      this.$emit('blur');
      this.$refs['sel'].close && this.$refs['sel'].close();
    },
    select: function select() {
      this.$refs['sel'] && this.$refs['sel'].$refs && this.$refs['sel'].$refs['input'].select();
    },
    search: function search(query, cb) {
      var _this = this;

      var result = [];

      if (this.code && this.code.split('').length > 3) {
        api["a" /* default */].lookupHSCode(this.$serverURL, this.code).then(function (data) {
          _this.hscodes = data;
          cb(data);
        }).catch(function (err) {
          cb(result);
          console.debug(err);
        });
      } else {
        cb(result);
      }
    },
    handlerSelect: function handlerSelect(item) {
      var _this2 = this;

      console.log('select handler item', item);

      if (!item.codeTs && this.hscodes && this.hscodes.length > 0) {
        this.code = this.hscodes[0].codeTs;
      } else {
        this.code = item.codeTs;
      }

      if (this.code) {
        api["a" /* default */].getHsCode(this.$serverURL, this.code).then(function (data) {
          _this2.$emit('input', _this2.code);

          _this2.$emit('change', _this2.code);

          _this2.$emit('product', data);
        }).catch(function (e) {
          _this2.$message.error(e);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2056e278","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HscodeSelect.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-autocomplete", {
    ref: "sel",
    attrs: {
      debounce: 10,
      "fetch-suggestions": _vm.search,
      "select-when-unmatched": true,
      disabled: _vm.disabled,
      placeholder: "请选择商品编码",
      "popper-class": "select-width-120"
    },
    on: {
      select: _vm.handlerSelect,
      blur: _vm.handlerBlur,
      change: _vm.handlerChange,
      focus: function($event) {
        return _vm.focusedHandler("sel")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var item = ref.item
          return [_c("div", [_vm._v(_vm._s(item.codeTs))])]
        }
      }
    ]),
    model: {
      value: _vm.code,
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

if (false) {}
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/HscodeSelect.vue
var disposed = false
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  HscodeSelect,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/HscodeSelect.vue"

/* hot reload */
if (false) {}

/* harmony default export */ var components_HscodeSelect = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/api/index.js + 1 modules
var api = __webpack_require__(0);

// EXTERNAL MODULE: ./src/components/VariationSelect.vue + 2 modules
var VariationSelect = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContainerTypeSelect.vue
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ContainerTypeSelect = ({
  name: 'ContainerTypeSelect',
  components: {
    VariationSelect: VariationSelect["a" /* default */]
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    justDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      options: [],
      codeValue: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.codeValue = val;
    }
  },
  created: function created() {
    this.getContainer();
  },
  methods: {
    focus: function focus() {
      !this.disabled && this.$refs['sel'].focus && this.$refs['sel'].focus();
    },
    blur: function blur() {
      this.$refs['sel'].close && this.$refs['sel'].close();
    },
    select: function select() {
      this.$refs['sel'].select();
    },
    change: function change(val) {
      var option = this.options.find(function (o) {
        return o.codeValue === val;
      });
      this.$emit('change', val, option);
      this.$emit('input', val);
    },
    blurHandler: function blurHandler() {
      this.$emit('blur');
    },
    focusHandler: function focusHandler() {
      this.$emit('focus');
    },
    getContainer: function getContainer() {
      var _this = this;

      api["a" /* default */].gbList(this.$serverURL, 'CUS_MAPPING_NORMS_CODE_V').then(function (nv) {
        _this.options = nv.map(function (v) {
          v.label = "".concat(v.codeValue, " ").concat(v.codeName, " ").concat(v.ciqCode);
          v.value = v.codeValue;
          return v;
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8190a92","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContainerTypeSelect.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("variation-select", {
    ref: "sel",
    attrs: { "just-display": _vm.justDisplay, options: _vm.options },
    on: { change: _vm.change, blur: _vm.blurHandler, focus: _vm.focusHandler },
    model: {
      value: _vm.codeValue,
      callback: function($$v) {
        _vm.codeValue = $$v
      },
      expression: "codeValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

if (false) {}
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ContainerTypeSelect.vue
var disposed = false
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ContainerTypeSelect,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ContainerTypeSelect.vue"

/* hot reload */
if (false) {}

/* harmony default export */ var components_ContainerTypeSelect = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/api/index.js + 1 modules
var api = __webpack_require__(0);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/OtherPacks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var OtherPacks = ({
  name: 'OtherPacks',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      packTypes: [],
      otherPacks: this.mergeValue(this.value),
      otherPacksDialogVisible: false,
      selections: [],
      otherPacksName: null
    };
  },
  watch: {
    value: function value(val) {
      this.otherPacks = this.mergeValue(val);

      if (this.otherPacks && this.otherPacks.length) {
        this.otherPacksName = this.otherPacks.map(function (m) {
          return m.packTypeName;
        }).join(',');
      } else {
        this.otherPacksName = null;
      }
    }
  },
  created: function created() {
    var _this = this;

    api["a" /* default */].gbList(this.$serverURL, 'CUS_MAPPING_PACKAGEKIND_CODE_V').then(function (data) {
      if (data) {
        _this.packTypes = data.map(function (m, index) {
          return {
            packSeqNo: "".concat(index + 1),
            packQty: '0',
            packType: m.codeValue,
            packTypeName: m.codeName,
            state: null
          };
        });
      }
    });
  },
  methods: {
    mergeValue: function mergeValue(val) {
      if (val) {
        return JSON.parse(JSON.stringify(val));
      } else {
        return [];
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.otherPacks = val;
    },
    otherPacksEdit: function otherPacksEdit() {
      var _this2 = this;

      this.otherPacksDialogVisible = true;
      var packSeqNos = this.otherPacks.map(function (m) {
        return m.packSeqNo;
      });
      var otherPacks = this.packTypes.filter(function (f) {
        return packSeqNos.indexOf(f.packSeqNo) >= 0;
      });
      this.$nextTick(function () {
        _this2.toggleSelection(otherPacks);
      });
    },
    save: function save() {
      if (this.otherPacks.length) {
        this.otherPacksName = this.otherPacks.map(function (m) {
          return m.packTypeName;
        }).join(',');
      }

      this.otherPacksDialogVisible = false;
      this.$emit('input', this.otherPacks);
      this.$emit('change', this.otherPacks);
    },
    toggleSelection: function toggleSelection(rows) {
      var _this3 = this;

      this.$refs.multipleTable.clearSelection();

      if (rows) {
        rows.forEach(function (row) {
          _this3.$refs.multipleTable.toggleRowSelection(row, true);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429f417a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OtherPacks.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticStyle: { width: "100%" },
          attrs: { type: _vm.otherPacks.length ? "primary" : "" },
          on: { click: _vm.otherPacksEdit }
        },
        [_vm._v("其他包装")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.otherPacksDialogVisible,
            title: "编辑其他包装信息",
            width: "40%",
            top: "8vh",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.otherPacksDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.packTypes, height: "500" },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "packSeqNo", width: "55", label: "序号" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "packType", width: "155", label: "证书代码" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "packTypeName", label: "证书名称" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.disabled, type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v("保 存")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

if (false) {}
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/OtherPacks.vue
var disposed = false
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  OtherPacks,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/OtherPacks.vue"

/* hot reload */
if (false) {}

/* harmony default export */ var components_OtherPacks = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/api/index.js + 1 modules
var api = __webpack_require__(0);

// EXTERNAL MODULE: ./src/components/entercomms.js
var entercomms = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GoodsAttrs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var GoodsAttrs = ({
  name: 'GoodsAttrs',
  mixins: [entercomms["a" /* default */]],
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      goodsAttrName: null,
      check: [],
      goodsAttrs: [],
      dialogVisible: false
    };
  },
  watch: {
    value: function value(val) {
      this.check = val ? val.split(',') : [];
      this.change();
    },
    check: function check(val) {
      this.goodsAttrName = this.goodsAttrs.filter(function (attr) {
        return val.indexOf(attr.codeValue) !== -1;
      }).map(function (attr) {
        return attr.codeName;
      }).join(',');
    }
  },
  created: function created() {
    this.check = this.value ? this.value.split(',') : [];
    this.initData();
  },
  methods: {
    goodsAttrEdit: function goodsAttrEdit(goodsAttr) {
      this.focusedHandler('goodsAttrName');
      this.dialogVisible = true;
    },
    initData: function initData() {
      var _this = this;

      api["a" /* default */].depList('http://localhost:8080/', 'CIQ_GOODS_ATTR').then(function (data) {
        _this.goodsAttrs = data;
      });
    },
    save: function save() {
      if (this.check && this.check.length <= 7) {
        this.dialogVisible = false;
        this.change();
      } else if (this.check.length > 7) {
        this.$message.error('最多选择7项');
      }
    },
    change: function change() {
      this.$emit('input', this.check.join(','));
      this.$emit('change', this.check.join(','));
    },
    focus: function focus() {
      !this.disabled && this.$refs['goodsAttrName'].focus && this.$refs['goodsAttrName'].focus();
    },
    blur: function blur() {
      this.$refs['goodsAttrName'].blur();
    },
    select: function select() {
      this.$refs['goodsAttrName'].select();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-955c71c8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodsAttrs.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-attrs" },
    [
      _c("el-input", {
        ref: "goodsAttrName",
        attrs: { disabled: _vm.disabled },
        on: {
          blur: function($event) {
            return _vm.$emit("blur")
          },
          select: function($event) {
            return _vm.$emit("select")
          },
          focus: function($event) {
            return _vm.goodsAttrEdit(_vm.check)
          }
        },
        model: {
          value: _vm.goodsAttrName,
          callback: function($$v) {
            _vm.goodsAttrName = $$v
          },
          expression: "goodsAttrName"
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "货物属性",
            width: "50%",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-checkbox-group",
            {
              attrs: { disabled: _vm.disabled },
              on: { change: _vm.change },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.save($event)
                }
              },
              model: {
                value: _vm.check,
                callback: function($$v) {
                  _vm.check = $$v
                },
                expression: "check"
              }
            },
            _vm._l(_vm.goodsAttrs, function(item) {
              return _c(
                "el-checkbox",
                {
                  key: item.codeValue,
                  attrs: { label: item.codeValue, border: "" }
                },
                [_vm._v(_vm._s(item.codeValue + "-" + item.codeName))]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("button", {
                staticStyle: { display: "none" },
                attrs: { type: "submit" }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

if (false) {}
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/GoodsAttrs.vue
var disposed = false
function injectStyle (context) {
  if (disposed) return
  __webpack_require__(27)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-955c71c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  GoodsAttrs,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/GoodsAttrs.vue"

/* hot reload */
if (false) {}

/* harmony default export */ var components_GoodsAttrs = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "depList", function() { return depList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gbList", function() { return gbList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHsCode", function() { return getHsCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ciqList", function() { return ciqList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookupHSCode", function() { return lookupHSCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElements", function() { return getElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getManual", function() { return getManual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getManualHead", function() { return getManualHead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImportManualItem", function() { return getImportManualItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExportManualItem", function() { return getExportManualItem; });
/* harmony import */ var _components_CodeSelect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CodeSelect", function() { return _components_CodeSelect__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _components_CiqCodeSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CiqCodeSelect", function() { return _components_CiqCodeSelect__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _components_HscodeSelect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HscodeSelect", function() { return _components_HscodeSelect__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _components_ContainerTypeSelect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContainerTypeSelect", function() { return _components_ContainerTypeSelect__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _components_OtherPacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OtherPacks", function() { return _components_OtherPacks__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _components_GoodsAttrs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(0);
/* harmony import */ var _components_VariationSelect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VariationSelect", function() { return _components_VariationSelect__WEBPACK_IMPORTED_MODULE_7__["a"]; });









var depList = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].depList,
    gbList = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].gbList,
    getHsCode = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].getHsCode,
    ciqList = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].ciqList,
    lookupHSCode = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].lookupHSCode,
    getElements = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].getElements,
    getManual = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].getManual,
    getManualHead = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].getManualHead,
    getImportManualItem = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].getImportManualItem,
    getExportManualItem = _components_api__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].getExportManualItem;

var components = [_components_CodeSelect__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], _components_CiqCodeSelect__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _components_HscodeSelect__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _components_ContainerTypeSelect__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _components_OtherPacks__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], _components_GoodsAttrs__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], _components_VariationSelect__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]];
var plugin = {
  install: function install(Vue) {
    var ops = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    components.forEach(function (component) {
      Vue.component(component.name, component);
    });
    Vue.prototype.$serverURL = ops.serverURL;
  }
}; // Auto-install

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(15)))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(17);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(5).default
var update = add("96d2c680", content, false, {});
// Hot Module Replacement
if(false) {}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// Module
exports.push([module.i, "\n.el-autocomplete-suggestion li[data-v-4c7d36f9] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  line-height: 1.7;\n}\n.el-autocomplete-suggestion li.highlighted[data-v-4c7d36f9] {\n  background-color: rgb(109, 163, 245);\n}\n.box[data-v-4c7d36f9] {\n  display: table;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  line-height: 1.2;\n  padding: 5px 0;\n}\n.name[data-v-4c7d36f9] {\n  display: table-cell;\n  width: 150px;\n  vertical-align: middle;\n  white-space: pre-wrap;\n}\n.code[data-v-4c7d36f9] {\n  display: table-cell;\n  width: 36px;\n  vertical-align: middle;\n  padding-left: 10px;\n  opacity: 0.8;\n}\n", ""]);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(19);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var timeout = __webpack_require__(21);
var events = __webpack_require__(23);

/**
 * Find out if an object has a certain property
 *
 * @param {object} object
 * @param {string} key
 */
function has(object, key){
    return Object.prototype.hasOwnProperty.call(object, key);
}

/**
 * Cache class
 */
function Cache(){
    this.initialize.apply(this, arguments);
}
var _ = Cache.prototype;
events.mixin(_);

/**
 * Constructor
 *
 * @param {object} external Forward set, get, clear and del commands to an external handler (optional)
 */
_.initialize = function(external){
    this.store = {};
    this.external = external;
};

/**
 * Insert or overwrite data
 *
 * @param {string} key
 * @param {mixed} value
 * @param {number} ttl   Time to live in milliseconds (optional)
 */
_.set = function(key, value, ttl){
    if(typeof key === 'undefined') throw new Error('Required argument key is undefined');

    // Clear timeout on existing record
    var oldRecord = has(this.store, key)? this.store[key] : undefined;
    if(oldRecord && oldRecord.timeout){
        timeout.clear(oldRecord.timeout);
    }

    // Set value + timeout on new record
    var record = {value: value};
    if(typeof ttl === 'number'){
        record.timeout = timeout.set(this.delInternal.bind(this, key), ttl);
    }
    this.store[key] = record;

    // Call external handler
    if(this.external && typeof this.external.set === 'function'){
        this.external.set(key, value, ttl);
    }

    // Emit update/set events
    var action = oldRecord? 'update' : 'set';
    this.trigger(action, key, value, ttl);
    this.trigger(action + ':' + key, value, ttl);
};

/**
 * Get cached data
 *
 * @param {string} key
 * @param {function} callback  Return value in callback if records exists locally or on external resource (optional)
 * @return {mixed} value Only returned if callback is undefined
 */
_.get = function(key, callback){
    if(typeof key === 'undefined') throw new Error('Required argument key is undefined');
    if(has(this.store, key)){
        if(typeof callback === 'function'){
            process.nextTick(callback.bind(null, this.store[key].value));
        }else{
            return this.store[key].value;
        }
    }else if(typeof callback === 'function' && this.external && typeof this.external.get === 'function'){
        this.external.get(key, callback);
    }
};

/**
 * Delete cached data
 *
 * @param {string} key
 * @return {boolean} Returns true if record existed
 */
_.del = function(key){
    if(typeof key === 'undefined') throw new Error('Required argument key is undefined');
    if(this.external && typeof this.external.del === 'function'){
        this.external.del(key);
    }
    return this.delInternal(key);
};

_.delInternal = function(key){
    if(has(this.store, key)){

        // Clear timeout
        if(this.store[key].timeout){
            timeout.clear(this.store[key].timeout);
        }

        // Delete record
        delete this.store[key];

        // Emit del events
        this.trigger('del', key);
        this.trigger('del:' + key);
        return true;
    }else{
        return false;
    }
};

/**
 * Clear cached data
 *
 * @return {number} Returns number of cleared records
 */
_.clear = function(){
    var size = this.size();
    this.store = {};
    if(this.external && typeof this.external.clear === 'function'){
        this.external.clear();
    }
    this.trigger('clear', size);
    return size;
};

/**
 * Retrieve number of records
 *
 * @return {number}
 */
_.size = function(){
    var size = 0;
    for(var key in this.store){
        if(has(this.store, key)) size++;
    }
    return size;
};

/**
 * Retrieve internal store
 *
 * @return {object}
 */
_.debug = function(){
    return this.store;
};

/**
 * Retrieve list of keys
 *
 * @return {string[]}
 */
_.keys = function(){
    return Object.keys(this.store);
};


/**
 * Export a combined instance and constructor
 */
var instance = new Cache();
var constructor = function(){
    return new Cache(arguments[0]);
};
constructor.Cache = Cache;
for(var key in _){
    if(has(_, key) && typeof _[key] === 'function'){
        constructor[key] = _[key].bind(instance);
    }
}
module.exports = constructor;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

(function(exports){
    var MAX_INT = 2147483647;
    var timeouts = {};
    var index = 1;

    // Set new timeout
    var set = function(callback, timeout){
        var id = index++;
        if(timeout > MAX_INT){
            timeouts[id] = setTimeout(set.bind(undefined, callback, timeout - MAX_INT), MAX_INT);
        }else{
            if(timeout < 0) timeout = 0;
            timeouts[id] = setTimeout(function(){
                delete timeouts[id];
                callback();
            }, timeout);
        }
        return id;
    };

    // Clear existing timeout
    var clear = function(id){
        if(timeouts.hasOwnProperty(id)){
            clearTimeout(timeouts[id]);
            delete timeouts[id];
        }
    };

    // Expose public interface
    exports.set = set;
    exports.clear = clear;
    exports._timeouts = timeouts;

})( false? undefined : exports);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(24);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Standalone extraction of Backbone.Events, no external dependency required.
 * Degrades nicely when Backone/underscore are already available in the current
 * global context.
 *
 * Note that docs suggest to use underscore's `_.extend()` method to add Events
 * support to some given object. A `mixin()` method has been added to the Events
 * prototype to avoid using underscore for that sole purpose:
 *
 *     var myEventEmitter = BackboneEvents.mixin({});
 *
 * Or for a function constructor:
 *
 *     function MyConstructor(){}
 *     MyConstructor.prototype.foo = function(){}
 *     BackboneEvents.mixin(MyConstructor.prototype);
 *
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * (c) 2013 Nicolas Perriault
 */
/* global exports:true, define, module */
(function() {
  var root = this,
      nativeForEach = Array.prototype.forEach,
      hasOwnProperty = Object.prototype.hasOwnProperty,
      slice = Array.prototype.slice,
      idCounter = 0;

  // Returns a partial implementation matching the minimal API subset required
  // by Backbone.Events
  function miniscore() {
    return {
      keys: Object.keys || function (obj) {
        if (typeof obj !== "object" && typeof obj !== "function" || obj === null) {
          throw new TypeError("keys() called on a non-object");
        }
        var key, keys = [];
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            keys[keys.length] = key;
          }
        }
        return keys;
      },

      uniqueId: function(prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
      },

      has: function(obj, key) {
        return hasOwnProperty.call(obj, key);
      },

      each: function(obj, iterator, context) {
        if (obj == null) return;
        if (nativeForEach && obj.forEach === nativeForEach) {
          obj.forEach(iterator, context);
        } else if (obj.length === +obj.length) {
          for (var i = 0, l = obj.length; i < l; i++) {
            iterator.call(context, obj[i], i, obj);
          }
        } else {
          for (var key in obj) {
            if (this.has(obj, key)) {
              iterator.call(context, obj[key], key, obj);
            }
          }
        }
      },

      once: function(func) {
        var ran = false, memo;
        return function() {
          if (ran) return memo;
          ran = true;
          memo = func.apply(this, arguments);
          func = null;
          return memo;
        };
      }
    };
  }

  var _ = miniscore(), Events;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Mixin utility
  Events.mixin = function(proto) {
    var exports = ['on', 'once', 'off', 'trigger', 'stopListening', 'listenTo',
                   'listenToOnce', 'bind', 'unbind'];
    _.each(exports, function(name) {
      proto[name] = this[name];
    }, this);
    return proto;
  };

  // Export Events as BackboneEvents depending on current context
  if (true) {
    if ( true && module.exports) {
      exports = module.exports = Events;
    }
    exports.BackboneEvents = Events;
  }else {}
})(this);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(26);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(5).default
var update = add("594f16fe", content, false, {});
// Hot Module Replacement
if(false) {}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// Module
exports.push([module.i, "\n.el-autocomplete-suggestion li[data-v-4bcde36f] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  line-height: 1.7;\n}\n.el-autocomplete-suggestion li.highlighted[data-v-4bcde36f] {\n  background-color: rgb(109, 163, 245);\n}\n.box[data-v-4bcde36f] {\n  display: table;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  line-height: 1.2;\n  padding: 5px 0;\n}\n.name[data-v-4bcde36f] {\n  display: table-cell;\n  width: 150px;\n  vertical-align: middle;\n  white-space: pre-wrap;\n}\n.code[data-v-4bcde36f] {\n  display: table-cell;\n  width: 36px;\n  vertical-align: middle;\n  padding-left: 10px;\n  opacity: 0.8;\n}\n", ""]);


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(28);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(5).default
var update = add("60ee58f0", content, false, {});
// Hot Module Replacement
if(false) {}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// Module
exports.push([module.i, "", ""]);


/***/ })
/******/ ]);
});